import styled from 'vue3-styled-components';

export const RequiredDocumentsContainer = styled.div`
    text-align: left;
    max-height: none;
    overflow-y: visible;
`;

export const DocumentsHeader = styled.div`
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 10px;
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
    border-radius: 10px;
    border: 2px solid #0ea5e9;
`;

export const DocumentsTitle = styled.h3`
    font-size: 20px;
    font-weight: 700;
    color: #0c4a6e;
    margin: 0 0 8px 0;
`;

export const DocumentsDescription = styled.p`
    font-size: 14px;
    color: #0369a1;
    margin: 0;
    line-height: 1.4;
`;

export const DocumentsSection = styled.div`
    margin-bottom: 24px;
`;

export const DocumentItem = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 10px;
    margin-bottom: 12px;
    background: #ffffff;
    border: 2px solid #e2e8f0;
    border-radius: 10px;
    transition: all 0.2s ease;
    position: relative;

    &:before {
        content: '•';
        color: #0f4c5c;
        font-size: 30px;
        font-weight: bold;
        margin-left: 5px;
        margin-right: 5px;
        display: inline-block;
        line-height: 1.2;
        position: relative;
    }
    
    &:hover {
        border-color: #0f4c5c;
        box-shadow: 0 4px 12px rgba(15, 76, 92, 0.1);
        transform: translateY(-1px);
    }
    
    &.required {
        background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
        border-color: #22c55e;
    }
`;

export const DocumentContent = styled.div`
    flex: 1;
`;

export const DocumentName = styled.div`
    font-size: 15px;
    font-weight: 600;
    color: #1e293b;
    margin: 0 0 6px 0;
`;

export const DocumentDescription = styled.div`
    font-size: 13px;
    color: #64748b;
    margin: 0;
    line-height: 1.4;
`;

export const DocumentsTips = styled.div`
    background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
    border: 2px solid #f59e0b;
    border-radius: 16px;
    padding: 20px;
    margin-top: 20px;
`;

export const TipsTitle = styled.h4`
    font-size: 16px;
    font-weight: 600;
    color: #92400e;
    margin: 0 0 12px 0;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const TipItem = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 8px;
    font-size: 13px;
    color: #a16207;
    line-height: 1.4;
    
    &:last-child {
        margin-bottom: 0;
    }
`;

export const TipBullet = styled.div`
    width: 6px;
    height: 6px;
    background: #f59e0b;
    border-radius: 50%;
    flex-shrink: 0;
    margin-top: 6px;
`;